import ComponentBasePrototype from 'ComponentBasePrototype';

export default class IframeCoverageMap extends BasePrototype {

}
